import type { SearchScenarioId } from 'owa-search-store';
import { action } from 'satcheljs';
import { addDatapointConfig } from 'owa-analytics-actions';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';

/**
 * Action dispatched when suggestions should be set in the store. Consuming client
 * should set up an orchestrator to subscribe to it, which should read appropriate
 * values from the search store, fetch suggestions, and set them in the store.
 */
export interface GET_SUGGESTIONSActionMessage {
    scenarioId: SearchScenarioId;
}
export const getSuggestions: (scenarioId: SearchScenarioId) => GET_SUGGESTIONSActionMessage =
    action(
        'GET_SUGGESTIONS',
        (scenarioId: SearchScenarioId): GET_SUGGESTIONSActionMessage =>
            addDatapointConfig(
                'Search_SuggestionsE2E',
                getModuleContextMailboxInfo(),
                {
                    unifiedTelemetry: {
                        eventName: 'PerformSearch',
                        data: {},
                    },
                },
                {
                    scenarioId,
                }
            )
    );
